import { Playground } from 'docz';
import Frame from "../../../../../src/components/Frame.tsx";
import SketchBarChart from "../../../../../src/components/SketchBarChart";
import * as React from 'react';
export default {
  Playground,
  Frame,
  SketchBarChart,
  React
};